"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IntegrationFieldRenderer = (ctx) => ({
    renderV1(content) {
        try {
            return {
                type: "IntegrationFields",
                value: ctx.Extension.encoders.integrationFields.encode(content.value),
            };
        }
        catch (e) {
            //todo report error somewhere
            return {
                value: {},
            };
        }
    },
    renderV2(_def, content) {
        try {
            return ctx.Extension.encoders.integrationFields.encode(content.value);
        }
        catch (e) {
            //todo report error somewhere
            return {};
        }
    },
    renderDefault(_def) {
        return null;
    },
    renderMocks(def) {
        return this.renderDefault(def);
    },
});
exports.default = IntegrationFieldRenderer;
